import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import locale from "@bonliva-crm/locale";

import RegularButton from "@components/buttons/RegularButton";
import PrimaryButton from "@components/buttons/PrimaryButton";
import {
  ReminderFormData,
  ReminderStore
} from "@containers/ReminderDialog/ReminderStore";
import {
  initialValues as DefaultInitialData,
  ReminderForm
} from "@containers/ReminderDialog/ReminderForm";
import { useLocalStore, useObserver } from "mobx-react";

type Props = {
  onClose: () => void;
  open: boolean;
  teamsDisabled: boolean;
  initialValues: ReminderFormData;
  onSkip: (e: React.SyntheticEvent<any>) => void;
  onSubmit: (values: ReminderFormData) => Promise<any>;
};

export function ReminderDialog(props: Props) {
  const skipBtnRef = React.createRef<HTMLButtonElement>();

  const { initialValues, onClose, onSkip, onSubmit, open, teamsDisabled } = props;
  const store = useLocalStore(() => new ReminderStore(onSubmit));

  useEffect(() => {
    if (open) {
      store.resetForm(initialValues || DefaultInitialData);
    }
  }, [open]);

  return useObserver(() => (
    <Dialog
      data-test="ReminderDialog"
      disableBackdropClick
      onClose={onClose}
      onEntered={(node) => {
        node.style.overflow = "visible";

        skipBtnRef.current && skipBtnRef.current.focus();
      }}
      onExit={(node) => (node.style.overflow = "hidden")}
      open={open}
      maxWidth="sm"
      style={{ minWidth: 400 }}
    >
      <DialogTitle>{locale["Set a reminder?"]}</DialogTitle>

      <DialogContent style={{ overflow: "auto" }}>
        <ReminderForm store={store} teamsDisabled={teamsDisabled} />
      </DialogContent>

      <DialogActions>
        <RegularButton style={{ marginRight: "auto" }} onClick={onClose}>
          {locale.Cancel}
        </RegularButton>
        <PrimaryButton
          disabled={!store.form.canSubmit}
          onClick={store.form.onSubmit}
          data-test="ReminderDialogOk"
        >
          {locale.Yes}
        </PrimaryButton>
        <RegularButton
          onClick={onSkip}
          data-test="ReminderDialogSkip"
          buttonRef={skipBtnRef}
        >
          {locale["Skip for now"]}
        </RegularButton>
      </DialogActions>
    </Dialog>
  ));
}
